import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { translate } from '../../../base/i18n/functions';
import { isMobileBrowser } from "../../../base/environment/utils";
const useStyles = makeStyles()(theme => {
    return {
        container: {
            position: 'absolute',
            left: 'calc(50% - 72px)',
            bottom: '8px'
        },
        newMessagesButton: {
            display: 'flex',
            alignItems: 'center',
            padding: '9px 15px',
            border: '1px solid rgba(255, 255, 255, 0.05)',
            borderRadius: '40px',
            backgroundColor: 'rgba(55, 55, 55, 1)',
            boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.05)',
            '&:hover': {
                backgroundColor: 'rgba(55, 55, 55, 1)',
            },
            '&:active': {
                backgroundColor: 'rgba(55, 55, 55, 1)',
            }
        },
        textContainer: {
            fontFamily: 'Lato Regular !important',
            fontWeight: 'normal',
            fontSize: '15px',
            lineHeight: '20px',
            color: 'rgba(255, 255, 255, 1)'
        }
    };
});
/** NewMessagesButton.
 *
 * @param {Function} onGoToFirstUnreadMessage - Function for lifting up onClick event.
 * @returns {JSX.Element}
 */
function NewMessagesButton({ onGoToFirstUnreadMessage, t }) {
    const { classes: styles } = useStyles();
    if (isMobileBrowser()) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: styles.container },
        React.createElement("button", { "aria-label": t('chat.newMessages'), className: styles.newMessagesButton, onClick: onGoToFirstUnreadMessage, type: 'button' },
            React.createElement("div", { className: styles.textContainer },
                " ",
                t('chat.newMessages')))));
}
export default translate(NewMessagesButton);
